import { initContract, ZodErrorSchema } from "@ts-rest/core";
import { Request } from "./request.js";
import { Conflict, Created, Err } from "./response.js";

export const contract = initContract().router({
  create: {
    method: "POST",
    path: "/physical-addresses",
    responses: {
      [201]: Created,
      [400]: ZodErrorSchema,
      [409]: Conflict,
      [500]: Err,
    },
    body: Request,
    summary: "Create a new physical address for an entity.",
  },
});
